// src/data/hire-ruby-and-rails.data.js

// Existing base data (kept as is, but now directly referenced within the main content object)
export const solutionsDataArabic = [
  {
    title: "الوصول إلى المواهب المدربة",
    description:
      "عندما توظف مبرمجي Ruby on Rails منا، تحصل على مطورين تم فحصهم بالكامل لخبرتهم التقنية ومهارات الاتصال. إنهم مستعدون لبناء تطبيقات عالية الجودة والعمل بسلاسة مع فريقك.",
    icon: "/images/hire-page-icons/chose-ror-section1.svg",
  },
  {
    title: "عرض التطابقات في ثوانٍ",
    description:
      "لا مزيد من إضاعة الوقت في البحث عن السير الذاتية التي لا نهاية لها! اعثر بسرعة على المرشح المناسب لمشروعك ببضع نقرات فقط. سواء كنت بحاجة إلى مطور RoR للتوظيف لمهمة قصيرة الأجل أو دور طويل الأجل، فإننا نجعل العملية سريعة وسهلة.",
    icon: "/images/hire-page-icons/chose-ror-section4.svg",
  },
  {
    title: "وفر مع التوظيف العالمي",
    description:
      "تمتد شبكتنا من مطوري Ruby on Rails إلى 190 دولة، مما يعني أن لديك وصولاً إلى مجموعة من 450,000 محترف موهوب. من خلال التوظيف عالميًا، يمكنك توفير ما يصل إلى 58% مقارنةً بطرق التوظيف التقليدية - دون المساومة على الجودة.",
    noBorder: true,
    icon: "/images/hire-page-icons/chose-ror-section3.svg",
  },
  {
    icon: "/images/hire-page-icons/chose-ror-section2.svg",
    title: "احصل على دعم الخبراء",
    description:
      "توظيف مطوري Ruby on Rails سهل مع خبراء التوظيف لدينا بجانبك. من العثور على المرشح المناسب إلى الحصول على أفضل المواهب لمشروعك، نضمن تجربة توظيف سلسة في كل خطوة على الطريق.",
  },
];

export const hireFaqDataArabic = [
  {
    id: "collapseOne",
    question: "ما هو Ruby on Rails (RoR)؟",
    answer:
      "Ruby on Rails هو إطار عمل كامل يسمح للمطورين ببناء تطبيقات ويب قابلة للتطوير وسريعة وآمنة. يستخدم Ruby كلغة برمجة ويتبع بنية Model-View-Controller (MVC).",
  },
  {
    id: "collapseTwo",
    question: "لماذا يجب علي توظيف مطوري Ruby on Rails؟",
    answer:
      "يضمن توظيف مبرمجي Ruby on Rails حصولك على تطبيق ويب قوي وموثوق وقابل للتطوير. RoR مثالي للتطوير السريع والصيانة السهلة وعملية التطوير المبسطة.",
  },
  {
    id: "collapseThree",
    question: "كيف يمكنني توظيف مبرمجي Ruby on Rails؟",
    answer:
      "يمكنك توظيف مطوري Ruby on Rails منا عن طريق تحديد نموذج التعاقد الخاص بك (دوام كامل أو جزئي أو بالساعة)، فحص المرشحين، ومقابلتهم للعثور على الأنسب لمشروعك.",
  },
  {
    id: "fourth",
    question: "ما أنواع المشاريع التي يمكنك بناؤها باستخدام Ruby on Rails؟",
    answer:
      "خدمات تطوير Ruby on Rails مثالية لبناء تطبيقات الويب القابلة للتطوير، وواجهات برمجة التطبيقات (APIs)، ومنصات التجارة الإلكترونية، وأنظمة إدارة المحتوى، والمزيد. إنه خيار مرن وقوي لأي مشروع ويب.",
  },
  {
    id: "fifth",
    question: "كم من الوقت يستغرق بناء مشروع باستخدام Ruby on Rails؟",
    answer:
      "يعتمد الجدول الزمني على تعقيد مشروعك. ومع ذلك، مع مطوري RoR المتاحين للتوظيف، يمكننا تطوير مشروعك بسرعة وكفاءة، وغالبًا ما نقلل وقت التطوير مقارنةً بأطر العمل الأخرى.",
  },
  {
    id: "sixth",
    question: "هل يمكنني ترحيل نظامي الحالي إلى Ruby on Rails؟",
    answer:
      "نعم! يمكن لشركتنا لتطوير Ruby on Rails مساعدتك في ترحيل تطبيقاتك أو أنظمتك الحالية بسلاسة إلى Ruby on Rails، مما يضمن انتقالًا سلسًا بأقل وقت تعطل.",
  },
];

export var mainBannerImgArabic = {
  backgroundImage: `url(/images/hire-page-images/hire-ror-banner-arabic.avif)`,
  factBackgroundImage: `url(/images/hire-page-images/hire-ror-quick-section-arabic.avif)`,
};

export const servicesDataArabic = [
  {
    title: "استشارات Ruby on Rails",
    description:
      "استفد من نصائح الخبراء والرؤى الاستراتيجية من مطوري RoR ذوي الخبرة لدينا. سواء كنت تطلق مشروعًا جديدًا أو تحسن مشروعًا قائمًا، فإننا نوجهك في كل خطوة على الطريق.",
    icon: "/images/hire-page-icons/hire-ror-icons1.svg",
  },
  {
    title: "تطوير الويب باستخدام Ruby on Rails",
    description:
      "بناء تطبيقات ويب غنية بالميزات وقابلة للتطوير مع مطوري RoR الخبراء لدينا. نضمن أداءً سلسًا ومرونة وصيانة خالية من المتاعب للحفاظ على حلول الويب الخاصة بك تعمل بسلاسة.",
    icon: "/images/hire-page-icons/hire-ror-icons2.svg",
  },
  {
    title: "تطوير واجهة برمجة تطبيقات Ruby on Rails",
    description:
      "يطور متخصصو RoR لدينا واجهات برمجة تطبيقات قوية تضمن التواصل السلس بين التطبيقات. سواء كنت تقوم بدمج خدمات طرف ثالث أو إدارة البيانات الداخلية، فنحن نوفر لك التغطية.",
    icon: "/images/hire-page-icons/hire-ror-icons3.svg",
  },
  {
    title: "تطوير أنظمة إدارة المحتوى والبوابات",
    description:
      "وظف مطوري RoR لدينا لبناء أنظمة إدارة محتوى (CMS) وبوابات ويب قابلة للتطوير والتخصيص. تضمن حلولنا سهولة الإدارة والتكيف مع متطلبات عملك الفريدة.",
    icon: "/images/hire-page-icons/hire-ror-icons4.svg",
  },
  {
    title: "الترحيل إلى Ruby on Rails",
    description:
      " هل تخطط للترحيل إلى Ruby on Rails؟ يضمن خبراؤنا انتقالًا سلسًا مع الحفاظ على سلامة البيانات والوظائف. ندير كل التفاصيل لترحيل سلس وخالي من المتاعب.",
    icon: "/images/hire-page-icons/hire-ror-icons5.svg",
  },
  {
    title: "التكامل مع الحلول الحالية",
    description:
      " عزز أنظمتك من خلال تكامل RoR السلس. يضمن مطورونا عمل تطبيقات Ruby on Rails الخاصة بك بسلاسة مع الأدوات الموجودة، مما يحسن الأداء والكفاءة.",
    icon: "/images/hire-page-icons/hire-ror-icons6.svg",
  },
  {
    title: "حلول التجارة الإلكترونية ROR",
    description:
      " تطوير منصة تجارة إلكترونية عالية الأداء مع خبراء RoR لدينا. نصمم متاجرًا عبر الإنترنت جذابة وغنية بالميزات مع تجارب مستخدم سلسة وقدرات إدارة سهلة.",
    icon: "/images/hire-page-icons/hire-ror-icons7.svg",
  },
  {
    title: "دعم وصيانة ROR",
    description:
      " حافظ على تشغيل تطبيقات Ruby on Rails الخاصة بك على النحو الأمثل من خلال خدمات الدعم والصيانة الخبيرة لدينا. نتعامل مع إصلاح الأخطاء وتحسينات الأداء والتحديثات لضمان وظائف غير منقطعة.",
    icon: "/images/hire-page-icons/hire-ror-icons8.svg",
  },
];

export const stepsArabic = [
  {
    title: "اختر نموذج التعاقد الخاص بك",
    description:
      "اختر نموذج التعاقد الذي يناسب احتياجاتك - دوام كامل أو جزئي أو بالساعة. سواء كنت بحاجة إلى شريك طويل الأجل أو شخص لمهمة قصيرة الأجل، لدينا خيارات مرنة.",
    icon: "/images/hire-page-setps-icons/icon-1.svg",
  },
  {
    title: "فحص واختيار مطوري Ruby On Rails",
    description:
      "تصفح مجموعتنا من مطوري RoR المهرة المتاحين للتوظيف. اختر أفضل المرشحين بناءً على ملفاتهم الشخصية واستعد للمضي قدمًا مع الأنسب لمشروعك.",
    icon: "/images/hire-page-setps-icons/icon-2.svg",
  },
  {
    title: "إجراء مقابلة فردية",
    description:
      "بعد أن تختار مرشحيك، قم بمقابلتهم لتقييم مهاراتهم. يمكنك طرح أسئلة نظرية وعملية لضمان أنهم المطابقون المثاليون لخدمات تطوير Ruby on Rails الخاصة بك.",
    icon: "/images/hire-page-setps-icons/icon-3.svg",
  },
  {
    title: "تأهيل مطوري Ruby on Rails",
    description:
      "بمجرد اتخاذ قرارك، سينضم المرشح النهائي إلى فريقك في غضون 24-48 ساعة بعد التأكيد. الأمر بهذه البساطة لجلب مطوري Ruby on Rails إلى مشروعك!",
    icon: "/images/hire-page-setps-icons/icon-4.svg",
  },
];

export const factsArabic = [
  {
    text: "<strong>أكثر من 40 مطور RoR ذو خبرة:</strong> يتكون فريقنا من أكثر من 40 مبرمج Ruby on Rails ماهر، مستعدون لبناء تطبيقات ويب قوية وقابلة للتطوير.",
  },
  {
    text: "<strong>متوسط الخبرة 25.98 سنة:</strong> مع ما يقرب من 26 عامًا من الخبرة المشتركة، يجلب مطورو RoR لدينا ثروة من الخبرة إلى كل مشروع.",
  },
  {
    text: "<strong>خبراء Ruby on Rails معتمدون: </strong>يضم فريقنا مطوري Ruby on Rails معتمدين لديهم معرفة عميقة بأحدث الأدوات وأطر العمل.",
  },
  {
    text: "<strong>خبرة في السحابة الأصلية واللامركزية:</strong> نحن متخصصون في بناء حلول تطوير ويب قابلة للتطوير باستخدام بنى سحابية أصلية ولا مركزية لضمان الموثوقية والأداء.",
  },
  {
    text: "<strong>ممارسات DevOps المتقدمة:</strong> يعمل مطورونا بثقافة DevOps ناضجة، مما يضمن تسليمًا سريعًا وآمنًا وفعالًا من خلال التكامل المستمر والتسليم المستمر (CI/CD).",
  },
  { text: "الاعتماد على <strong> ثقافة DevOps ناضجة.</strong>" },
  {
    text: "<strong>خبرة متعددة الاستخدامات:</strong> سواء كانت بيانات ضخمة، إنترنت الأشياء، تعلم الآلة، أو تكامل blockchain، فإن فريقنا لديه خبرة في التعامل مع المشاريع المعقدة والمبتكرة باستخدام Ruby on Rails.",
  },
];

export const hiringDetailsArabic = [
  {
    text: "التوظيف بالساعة", // Hourly Hiring
    hours: "24 - 48",
    timeUnit: "ساعة", // hours
    icon: "time.svg",
    bgColor: "#FDFDFF",
    durationLabel: "المدة", // Duration
    duration: "8 ساعات/يوم", // 8 Hrs/Day
    minimumDaysLabel: "الحد الأدنى للأيام", // Minimum Days
    minimumDays: "30 يوم", // 30 Days
    billingLabel: "الفوترة", // Billing
    billing: "شهرياً", // Monthly
    startWorkPhrase: "ابدأ العمل خلال " // Start work in
  },
  {
    text: "التوظيف بدوام كامل", // Full Time Hiring
    hours: "48",
    timeUnit: "ساعة", // hours
    icon: "full-time.svg",
    bgColor: "#FFFEFA",
    durationLabel: "المدة", // Duration
    duration: "8 ساعات/يوم", // 8 Hrs/Day
    minimumDaysLabel: "الحد الأدنى للأيام", // Minimum Days
    minimumDays: "30 يوم", // 30 Days
    billingLabel: "الفوترة", // Billing
    billing: "شهرياً", // Monthly
    startWorkPhrase: "ابدأ العمل في غضون " // Get started within
  },
  {
    text: "التوظيف بدوام جزئي", // Part Time Hiring
    hours: "24 - 48",
    timeUnit: "ساعة", // hours
    icon: "part-time.svg",
    bgColor: "#FDFFFA",
    durationLabel: "المدة", // Duration
    duration: "4 ساعات/يوم", // 4 Hrs/Day
    minimumDaysLabel: "الحد الأدنى للأيام", // Minimum Days
    minimumDays: "30 يوم", // 30 Days
    billingLabel: "الفوترة", // Billing
    billing: "شهرياً", // Monthly
    startWorkPhrase: "انطلق خلال " // Launch in
  },
];

export const tabsArabic = [
  "اللغات",
  "المكتبات ومكتبات واجهة المستخدم",
  "أطر العمل",
  "الاختبار",
  "المنصات",
];

export const tabItemsArabic = [
  { tab: "اللغات", name: "Ruby", icon: "/images/tech-stack-icons/ruby.svg" },
  { tab: "اللغات", icon: "/images/icon7.png", name: "HTML5" },
  { tab: "اللغات", icon: "/images/icon6.png", name: "CSS3" },
  { tab: "اللغات", icon: "/images/icontwo.png", name: "JavaScript" },

  {
    tab: "المكتبات ومكتبات واجهة المستخدم",
    icon: "/images/tech-stack-icons/bootstrap.svg",
    name: "Bootstrap",
  },
  {
    tab: "المكتبات ومكتبات واجهة المستخدم",
    icon: "/images/tech-stack-icons/tailwind.svg",
    name: "Tailwind CSS",
  },
  {
    tab: "المكتبات ومكتبات واجهة المستخدم",
    icon: "/images/tech-stack-icons/react.svg",
    name: "React.js",
  },
  {
    tab: "المكتبات ومكتبات واجهة المستخدم",
    icon: "/images/tech-stack-icons/angular.svg",
    name: "Angular",
  },
  {
    tab: "المكتبات ومكتبات واجهة المستخدم",
    icon: "/images/tech-stack-icons/vue-js.svg",
    name: "Vue.js",
  },

  { tab: "أطر العمل", name: "Ruby on Rails", icon: "/images/tech-stack-icons/rails.svg" },
  { tab: "أطر العمل", icon: "/images/tech-stack-icons/graph.svg", name: "GraphQl" },

  { tab: "المنصات", icon: "/images/cloud3.png", name: "AWS" },
  { tab: "المنصات", icon: "/images/DigitalOcean.png", name: "Digital Ocean" },
  { tab: "المنصات", icon: "/images/tech-stack-icons/heroku.svg", name: "Heroku" },

  { tab: "الاختبار", name: "Redis", icon: "/images/tech-stack-icons/rspec.svg" },
  { tab: "الاختبار", name: "Jest", icon: "/images/tech-stack-icons/jest.svg" },
];

export const techCombinationsArabic = [
  {
    title: "Ruby on Rails + React + PostgreSQL",
    description:
      "يساعد Ruby on Rails كإطار عمل خلفي، وReact لواجهة أمامية ديناميكية، وPostgreSQL كقاعدة بيانات في بناء تطبيقات ويب قابلة للتطوير وعالية الأداء.",
    icons: ["rails.svg", "react.svg", "postgres.svg"],
  },
  {
    title: "Ruby on Rails + Angular + MySQL",
    description:
      "يستخدم Ruby on Rails للمنطق من جانب الخادم، وAngular لواجهة أمامية حديثة، وMySQL كقاعدة بيانات علائقية موثوقة لإنشاء حلول ويب قوية للشركات.",
    icons: ["rails.svg", "angular.svg", "mysql-whale-icon.svg"],
  },
  {
    title: "Ruby on Rails + Vue.js + MongoDB",
    description:
      "توفر Vue.js في الواجهة الأمامية، وRuby on Rails كواجهة خلفية، وMongoDB كقاعدة بيانات NoSQL مجموعة فعالة لتطبيقات تفاعلية ومرنة.",
    icons: ["rails.svg", "vue-js.svg", "mongodb.svg"],
  },
  {
    title: "Ruby on Rails + GraphQL + PostgreSQL",
    description:
      "يتيح GraphQL استعلامات بيانات مرنة، ويتعامل Ruby on Rails مع منطق الخادم، ويضمن PostgreSQL تخزين بيانات آمن ومنظم للتطبيقات الحديثة.",
    icons: ["rails.svg", "graphql.svg", "postgres.svg"],
  },
];

export const schemaDataArabic = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "ما هو استخدام Ruby on Rails (RoR)؟",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Ruby on Rails (RoR) هو إطار عمل قوي لتطبيقات الويب يُستخدم لبناء مواقع ويب وتطبيقات ديناميكية تعتمد على قواعد البيانات. إنه مثالي لتطوير تطبيقات الويب القابلة للتطوير، ومنصات التجارة الإلكترونية، وأنظمة إدارة المحتوى، وحلول البرامج المخصصة.",
      },
    },
    {
      "@type": "Question",
      name: "كم تبلغ تكلفة التطوير باستخدام Ruby on Rails؟",
      acceptedAnswer: {
        "@type": "@Answer",
        text: "تختلف تكلفة التطوير باستخدام Ruby on Rails اعتمادًا على تعقيد مشروعك، وعدد الميزات المطلوبة، والجدول الزمني للتطوير. نقدم عروض أسعار مخصصة بناءً على احتياجاتك الخاصة لضمان حصولك على أفضل قيمة.",
      },
    },
    {
      "@type": "Question",
      name: "ما هو السعر بالساعة لمطور Ruby on Rails؟",
      acceptedAnswer: {
        "@type": "Answer",
        text: "يمكن أن يتراوح السعر بالساعة لمطور Ruby on Rails بشكل كبير بناءً على مستوى خبرتهم ومتطلبات المشروع. في Bitsclan، نقدم أسعارًا تنافسية تعكس خبرة وجودة مطوري RoR لدينا.",
      },
    },
    {
      "@type": "Question",
      name: "هل Ruby on Rails جيد لتطوير تطبيقات الويب؟",
      acceptedAnswer: {
        "@type": "Answer",
        text: "نعم، Ruby on Rails هو خيار ممتاز لتطوير تطبيقات الويب. يشتهر بكفاءته، وقابليته للتطوير، ودعم مجتمعي قوي، مما يجعله مثاليًا لبناء تطبيقات ويب قوية وعالية الأداء.",
      },
    },
    {
      "@type": "Question",
      name: "هل Ruby on Rails واجهة أمامية أم خلفية؟",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Ruby on Rails هو في الأساس إطار عمل خلفي، يتعامل مع منطق جانب الخادم، وتفاعلات قاعدة البيانات، وبنية التطبيق. ومع ذلك، يمكن دمجه بسلاسة مع تقنيات الواجهة الأمامية مثل HTML وCSS وJavaScript.",
      },
    },
    {
      "@type": "Question",
      name: "ما الذي يميز مطوري Ruby on Rails لديكم؟",
      acceptedAnswer: {
        "@type": "Answer",
        text: "يتميز مطورو Ruby on Rails لدينا بخبرتهم العميقة، والتزامهم بالجودة، وشغفهم بالابتكار. إنهم ماهرون في تقديم حلول مخصصة تتسم بالكفاءة وقابلية التوسع، مما يضمن نجاح مشروعك.",
      },
    },
  ],
};

// --- Consolidated Page Content Object ---
export const hireRubyAndRailsPageContentArabic = {
  // SEO Data
  helmet: {
    title: "وظّف مبرمجي Ruby on Rails | خدمات تطوير RoR",
    description:
      "وظف خبراء تطوير Ruby on Rails لتطبيقات الويب القابلة للتطوير والقوية. خدمات تطوير RoR مخصصة لتلبية احتياجات عملك.",
    schema: schemaDataArabic, // Reference schemaData directly
  },

  // HirePageBanner Component Props (following your requested structure)
  hirePageBanner: {
    diffBannerBackgroundImage: mainBannerImgArabic.backgroundImage,
    image: "", // Assuming this is consistently empty
    mainHeading: "وظف مطوري Ruby on Rails",
    content:
      "هل تبحث عن توظيف مبرمجي Ruby on Rails خبراء؟ فريق تطوير RoR الماهر لدينا مستعد لبناء تطبيقات ويب قابلة للتطوير، قوية، آمنة، وعالية الأداء مصممة خصيصًا لاحتياجاتك.",
    btnText: "استشر مطوري RoR لدينا",
    bannerList: [
      { list: "مطورون تم فحصهم مسبقًا" },
      { list: "أفضل المواهب" },
      { list: "محاذاة المنطقة الزمنية" },
      { list: "توظيف أسرع وأكثر فعالية من حيث التكلفة" },
    ],
  },

  // HirePageExperties Component Props
  hirePageExperties: {
    btnText: "حدد موعدًا لإجراء مكالمة اليوم",
    heading: "نقدم خدمات تطوير Ruby on Rails",
    discription:
      "في Bitsclan، نصمم حلولًا قابلة للتطوير، آمنة، وفعالة مصممة خصيصًا لاحتياجات عملك. مطورو RoR لدينا مستعدون لدعمك في كل مرحلة من مراحل التطوير، بما في ذلك الصيانة بعد الإطلاق. بصفتنا شركة رائدة في تطوير Ruby on Rails، نندمج بسلاسة مع مشاريعك، مما يتيح لك التركيز على نمو الأعمال.",
    servicesData: servicesDataArabic, // Reference servicesData directly
  },

  // DevelopmentPerformance Component Props
  developmentPerformance: {
    btnText: "توظيف مطور اليوم",
    heading: "لماذا تختارنا للتوظيف",
    greenHeading: "مبرمجي Ruby on Rails",
    subHeading:
      "في Bitsclan، نجمع بين Ruby on Rails وأحدث تقنيات الواجهة الأمامية والجوال لإنشاء تطبيقات قوية وقابلة للتطوير مثالية لاحتياجات عملك. سواء كنت تبني منصة ويب أو حلًا للجوال، يضمن نهجنا تطويرًا سريعًا وأداءً سلسًا وتجربة مستخدم سلسة.",
    solutions: solutionsDataArabic, // Reference solutionsData directly
  },

  // HireCombinationSection Component Props
  hireCombinationSection: {
    combinations: techCombinationsArabic, // Reference techCombinations directly
    heading: "أفضل تجميعات RoR للتطوير الاستثنائي",
    description:
      "فهمت! إليك كيفية هيكلة الأقسام لـ Ruby on Rails، باتباع نفس نمط الوصف مثل صورتك المرجعية.",
  },

  // HirePageSteps Component Props
  hirePageSteps: {
    btnText: "دعنا نجد المطور المثالي لك",
    heading: "وظف مبرمجي Ruby On Rails في 4 خطوات بسيطة",
    subHeading:
      "لم يكن توظيف مطوري RoR أسهل من أي وقت مضى! في Bitsclan، تضمن عمليتنا المبسطة المكونة من 4 خطوات حصولك على أفضل المواهب بسرعة وكفاءة وسلاسة.",
    steps: stepsArabic, // Reference steps directly
  },

  // CoverTheStack Component Props
  coverTheStack: {
    whereStart: "اللغات",
    mainHeading: "وظف خبراء Ruby on Rails لتطبيقات الويب القابلة للتطوير والآمنة",
    subHeading:
      "في Bitsclan، ندعم رحلة تطوير الويب الخاصة بك بمجموعة تقنية Ruby on Rails قوية تضمن الكفاءة وقابلية التوسع والأمان. يتخصص مطورو RoR ذوي الخبرة لدينا في بناء تطبيقات ويب مخصصة وعالية الأداء مصممة خصيصًا لاحتياجات عملك.",
    tabs: tabsArabic, // Reference tabs directly
    tabItems: tabItemsArabic, // Reference tabItems directly
  },

  // HireExpertFacts Component Props
  hireExpertFacts: {
    btnText: "حجز موعد",
    heading: "حقائق سريعة عن ",
    greenHeading: "فريق Ruby on Rails لدينا",
    facts: factsArabic, // Reference facts directly
    diffBannerBackgroundImage: mainBannerImgArabic.factBackgroundImage,
  },

  // HirePageAppIdea Component Props
  hirePageAppIdea: {
    heading: "لست متأكدًا من فكرة تطبيقك؟ احصل على النموذج الأولي خلال 6 إلى 8 أسابيع!",
    content:
      "وظف مطوري Ruby on Rails ماهرين لبناء تطبيقات ويب قابلة للتطوير وعالية الأداء مصممة خصيصًا لاحتياجات عملك. يتخصص خبراؤنا في التطوير السريع، مما يضمن حلولًا فعالة وقوية.",
  },

  // HirePageEngagementModels Component Props
  hirePageEngagementModels: {
    btnText: "ابدأ الآن",
    hiringDetails: hiringDetailsArabic, // Reference hiringDetails directly
    headingContent: [
      {
        "text": "نماذج تعاقدنا" // Our Engagement Models
      },
      {
        "text": "المرنة" // Flexible
      },
    ],
    discription: "في Bitsclan، نقدم نماذج تعاقد مرنة بناءً على احتياجاتك الخاصة. اختر من بين خيارات الدوام الكامل أو الجزئي أو بالساعة. وسواء كنت بحاجة إلى مطور RoR واحد للاستئجار أو فريق عمل مخصص، فإننا نضمن تعاونًا سلسًا وكفاءة عالية لمشروعك."
  },

  // TrendsInsights Component Props
  trendsInsights: {
    specificClass: "mobile-dev-page",
    category: "all",
  },

  // SecondFaq Component Props
  secondFaq: {
    faqs: hireFaqDataArabic, // Reference faqData directly
    specificClass: "mobile-dev-page",
    mainHeading: "الأسئلة المتداولة",
    subHeading: "اكتشف إجابات لأسئلة شائعة حول Ruby on Rails.",
  },
};